import {
  ApolloClient,
  useApolloClient,
  InMemoryCache,
  createHttpLink,
  defaultDataIdFromObject,
  useQuery,
  DocumentNode,
  gql
} from '@apollo/client'
import { useState, useEffect, useCallback } from 'react';
import * as types from './gql/graphql';
import { setContext } from '@apollo/client/link/context'
import supabase, { supabaseUrl, supabaseKey } from './supabase'

const cache = new InMemoryCache({
  dataIdFromObject(responseObject) {
    if ('nodeId' in responseObject) {
      return `${responseObject.nodeId}`
    }

    return defaultDataIdFromObject(responseObject)
  },

  /*     typePolicies: {
        Query: {
          fields: {
            fs_studentsCollection: {
              // Don't cache separate results based on
              // any of this field's arguments.
              keyArgs: false,
    
              // Concatenate the incoming list items with
              // the existing list items.
              merge(existing, incoming) {
                if(existing) {
                  const merged: types.Fs_StudentsConnection= { edges: [...existing.edges, ...incoming.edges], pageInfo: incoming.pageInfo };
                  return merged;
                }
                else return incoming;
                //return [...existing, ...incoming.edges];
              },
            }
          }
        }
      }   */


})


/*
  const {
    data: { session },
} = await supabase.auth.getSession()

const body = await fetch(`${supabaseUrl}/graphql/v1`, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        apikey: supabaseKey,
        Authorization: `Bearer ${session?.access_token ?? supabaseKey}`,
    },
    */




const httpLink = createHttpLink({
  uri: supabaseUrl + "/graphql/v1"
})

const authLink = setContext(async (_, { headers }) => {
  const {
    data: { session },
  } = await supabase.auth.getSession()

  return {
    headers: {
      apikey: supabaseKey,
      Authorization: `Bearer ${session?.access_token ?? supabaseKey}`,
    },
  }
})
/*const authLink = setContext(async (_, { headers }) => {
  const token = (await supabase.auth.getSession()).data.session?.access_token
 
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  }
})*/

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
})

export default apolloClient;

/*
const addPaginationFields = (query: string): string => {
  // Ensure pageInfo and edges are included if not present
  if (!query.includes('pageInfo')) {
    return query.replace(/(edges\s*{\s*node\s*{)/, `pageInfo { endCursor startCursor hasNextPage } $1`);
  }
  return query;
};

function addAfterParameter(query: string): string {
  // Check if the query already includes the `after` parameter
  if (!query.includes('$after')) {
    // Find the start of the query's parameter list, looking for the opening parenthesis
    const firstBraceIndex = query.indexOf('{');
    const firstParenIndex = query.indexOf('(', firstBraceIndex);

    // If there is an opening parenthesis, we assume the query uses variables
    if (firstParenIndex !== -1) {
      // Find the closing parenthesis that ends the parameter list
      const closingParenIndex = query.indexOf(')', firstParenIndex);

      // Check if we found both parentheses, indicating a parameter list
      if (closingParenIndex !== -1) {
        // Check if there are already variables (parameters) in the list
        const params = query.slice(firstParenIndex + 1, closingParenIndex).trim();

        // If there are existing parameters, we add `after: $after` to the list
        if (params) {
          query = query.slice(0, closingParenIndex) + ', after: $after' + query.slice(closingParenIndex);
        } else {
          // If no parameters exist, we simply add `after: $after` inside the parentheses
          query = query.slice(0, closingParenIndex) + 'after: $after' + query.slice(closingParenIndex);
        }
      }
    } else {

      if (firstBraceIndex !== -1) {
        // Find the first identifier (in this case, after the opening `{`)
        const firstIdentifierEndIndex = query.indexOf('{', firstBraceIndex + 1);

        // Insert the `after: $after` parameter after the first identifier
        query = query.slice(0, firstIdentifierEndIndex) + '(after: $after)' + query.slice(firstIdentifierEndIndex);
      }
    }
  }

  return query;
}



interface PageInfo {
  endCursor: string | null;
  hasNextPage: boolean;
}

interface QueryResult<T> {
  edges: T[];
  pageInfo: PageInfo;
}

interface UseAllItemsReturn<T> {
  allItems: T[];
  loading: boolean;
  error?: Error;
}

export function useAllItems<T>(query: string, parameters: Record<string, any> = {}): UseAllItemsReturn<T> {
  const [allItems, setAllItems] = useState<T[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [complete, setComplete] = useState(false);

  var updatedQuery = addPaginationFields(query);
  updatedQuery = addAfterParameter(updatedQuery);

  const updatedParameters = {
    ...parameters, variables: {
      ...parameters?.variables,
      after: cursor,
    },
  };

  const { data, loading, error, fetchMore } = useQuery<{ [key: string]: QueryResult<T> }>(gql(updatedQuery), {
    ...updatedParameters,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data) {

      const queryKey = Object.keys(data)[0];
      const { edges, pageInfo } = data[queryKey];

      if(complete) {
        setComplete(false);
        setCursor(null);
        setAllItems(edges);
      } else {
        setAllItems((prev) => [...prev, ...edges]);
      }

      if (pageInfo.hasNextPage) {
        setCursor(pageInfo.endCursor);
      } else {
        setComplete(true);
      }
    }
  }, [data]);

  useEffect(() => {
    if (cursor) {
      fetchMore({ variables: { after: cursor } });
    }
  }, [cursor]);

  return { allItems: complete ? allItems : undefined, loading: !complete, error };
}*/


///////////////////////////////////////////////////////////////////////
interface UseQueryAllOptions<TVariables> {
  query: DocumentNode;
  variables?: TVariables;
}

export function useQueryAll<TNode, TVariables = {}>({ 
  query,
  variables,
}: UseQueryAllOptions<TVariables>) {
  const [allNodes, setAllNodes] = useState<TNode[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const { data, loading, error, fetchMore, refetch, networkStatus } = useQuery(query, {
    variables: { ...variables, after: null },
    fetchPolicy: 'network-only', // skip Apollo cache
    notifyOnNetworkStatusChange: true,
  });

  const fetchingMore = networkStatus === 3;
  const ready = done && !loading && !fetchingMore;

  if((networkStatus === 4 || networkStatus === 1 || networkStatus === 2) && done) { // Refetch in progress
    setAllNodes([]);
    setDone(false);
    setCursor(null);
  }

  useEffect(() => {
    if (data && !loading && !done) {
      const queryKey = Object.keys(data)[0];
      const { edges, pageInfo } = data[queryKey];
      setAllNodes(prev => [...prev, ...edges]);

      if (pageInfo.hasNextPage) {
        setCursor(pageInfo.endCursor);
      } else {
        setDone(true);
      }
    }
  }, [loading]);

  useEffect(() => {
    if (cursor) {
      fetchMore({
        variables: {
          ...variables,
          after: cursor,
        },
        updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
      });
    }
  }, [cursor]);

  const refetchAll = (variables) => {
    setAllNodes([]);
    setCursor(null);
    setDone(false);
    refetch(variables);
  };

  return {
    data: ready? allNodes:undefined,
    loading: !ready,
    error,
    refetchAll,
  };
}

///////////////////////////////////////////////////////////////


interface FetchAllOptions<TData, TVariables extends Record<string, unknown>> {
  query: DocumentNode;
  variables?: Omit<TVariables, "after">;
  pageSize?: number;
  // Tell the hook where to find pageInfo and edges in your query result
  getPageInfo: (data: TData) => types.PageInfo;
  getItems: (data: TData) => unknown[];
}

interface FetchAllState<T> {
  items: T[];
  loading: boolean;
  error: Error | null;
  progress: { fetched: number; done: boolean };
}

export function useFetchAll<TData, TVariables extends Record<string, unknown>, TItem>() {
  const client = useApolloClient();
  const [state, setState] = useState<FetchAllState<TItem>>({
    items: [],
    loading: false,
    error: null,
    progress: { fetched: 0, done: false },
  });

  const fetchAll = async ({
    query,
    variables = {} as Omit<TVariables, "after">,
    pageSize = 100,
    getPageInfo,
    getItems,
  }: FetchAllOptions<TData, TVariables>) => {
    //setState({ items: state.items, loading: true, error: null, progress: { fetched: 0, done: false } });

    const allItems: TItem[] = [];
    let cursor: string | null = null;
    let hasNextPage = true;

    try {
      while (hasNextPage) {
        const { data } = await client.query<TData>({
          query,
          variables: { ...variables, first: pageSize, after: cursor },
          // 'cache-first' reads from cache if already fetched,
          // 'network-only' forces fresh fetch every time
          fetchPolicy: "network-only",
        });

        const items = getItems(data) as TItem[];
        const pageInfo = getPageInfo(data);

        allItems.push(...items);
        cursor = pageInfo.endCursor;
        hasNextPage = pageInfo.hasNextPage;

        // // Update progress after each page so UI can react
        // setState((prev) => ({
        //   ...prev,
        //   //items: [...allItems],
        //   progress: { fetched: allItems.length, done: !hasNextPage },
        // }));
      }

      setState((prev) => ({
        ...prev,
        items: allItems,
        loading: false,
        progress: { fetched: allItems.length, done: true },
      }));
    } catch (err) {
      setState((prev) => ({
        ...prev,
        loading: false,
        error: err instanceof Error ? err : new Error("Unknown error"),
      }));
    }
  };

  return { ...state, fetchAll };
}